<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

                "parkCode":"2KNTYVWC"
            },
            responseCode: {
                "data": {
                    "parkCode":"2KNTYVWC",
                    "eptCarports":"111"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取单个停车场实时车位信息",
                t_url: this.commonUrls.test+"getParkRemainCarport",
                p_url: this.commonUrls.prod+"getParkRemainCarport",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'areaCode', info2: '否', info3: 'String', info4: '区域编号' },
                        { info1: 'areaId', info2: '否', info3: 'Long', info4: ' 区域id' },
                        {  info3: '注：',info4: '传areaCode 或 areaId 返回为区域剩余车位数据' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'totalRemainCount', info2: '是', info3: 'Integer', info4: '总空车位数' },
                        { info1: 'totalPermitCount', info2: '是', info3: 'Integer', info4: '总车位数' },
                        { info1: 'normalPermitCount', info2: '否', info3: 'Integer', info4: '临时车位数' },
                        { info1: 'normalRemainCount', info2: '否', info3: 'Integer', info4: '剩余临时车位数' },
                        { info1: 'lastUpdateTime', info2: '否', info3: 'String', info4: '最近更新时间：yyyyMMddHHmmss' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkRemainCarport.vue